(function ($, Drupal) {
  Drupal.behaviors.fancyboxBehavior = {
    attach: function (context, settings) {
      // Cibler toutes les images dans le contenu
      $("article img", context).each(function () {
        // Vérifier si l'image a déjà été modifiée pour éviter la duplication
        if (!$(this).hasClass("fancybox-processed")) {
          // Ajouter automatiquement l'attribut data-fancybox pour toutes les images.
          //$(this).attr("data-fancybox", "gallery");

          // Si l'image n'est pas déjà dans un lien, l'encapsuler dans un lien.
          if (!$(this).parent("a").length) {
            $(this).wrap(
              '<a href="' +
                $(this).attr("src") +
                '" data-fancybox="gallery"></a>'
            );
          }

          // Ajouter une classe pour marquer l'image comme "traitée"
          $(this).addClass("fancybox-processed");
        }
      });

      // Initialiser explicitement FancyBox sur les éléments qui ont l'attribut data-fancybox
      //Fancybox.bind("[data-fancybox]", {});
    },
  };
})(jQuery, Drupal);
